module.exports = __webpack_public_path__ + "img/legend-of-aurum-draconis-smaller.eaf95273.png";